/* Kauil Ki · Caja Descubre: galería, cantidad, resumen, guía de picor, reseñas y barra fija. */
(function () {
  function money(cents) {
    var v = Math.round(cents) / 100;
    return '$' + v.toLocaleString('es-MX', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function pl(n, a, b) { return n + ' ' + (n === 1 ? a : b); }

  function init(root) {
    if (!root || root.dataset.kkListo) return;
    root.dataset.kkListo = '1';
    var precio = parseInt(root.dataset.precio, 10) || 0;
    var desc2 = parseInt(root.dataset.desc2, 10) || 0;
    var nsal = parseInt(root.dataset.nsal, 10) || 4;
    var tipo = root.dataset.tipo || '';
    var nombre = root.dataset.producto || '';
    var $ = function (s) { return root.querySelector(s); };

    /* Restaurar posición al cambiar de caja */
    try {
      var guardado = sessionStorage.getItem('kkScroll');
      if (guardado) { sessionStorage.removeItem('kkScroll'); window.scrollTo(0, parseInt(guardado, 10) || 0); }
    } catch (e) {}
    root.querySelectorAll('[data-kk-sw]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (a.getAttribute('aria-current') === 'true') { e.preventDefault(); return; }
        try { sessionStorage.setItem('kkScroll', String(window.scrollY)); } catch (err) {}
      });
      var pre = function () {
        if (a.dataset.pre) return; a.dataset.pre = '1';
        var l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
      };
      a.addEventListener('pointerenter', pre, { passive: true });
      a.addEventListener('touchstart', pre, { passive: true });
    });

    /* Galería */
    var movil = $('[data-kk-gal-movil]');
    if (movil) {
      movil.addEventListener('scroll', function () {
        var f = movil.firstElementChild; if (!f) return;
        var w = f.getBoundingClientRect().width + 10;
        var i = movil.scrollLeft >= movil.scrollWidth - movil.clientWidth - 2 ? movil.children.length - 1 : Math.round(movil.scrollLeft / w);
        root.querySelectorAll('.kk-punto').forEach(function (p, k) { p.classList.toggle('on', k === i); });
      }, { passive: true });
    }
    var esc = $('[data-kk-gal-esc]');
    if (esc) {
      var total = parseInt(esc.dataset.total, 10) || 1, act = 0;
      var principal = $('[data-kk-principal]');
      var pintarFoto = function () {
        var t = esc.querySelector('template[data-kk-foto="' + act + '"]');
        if (t && principal) {
          principal.innerHTML = '';
          principal.appendChild(t.content.cloneNode(true));
          var img = principal.querySelector('img'); if (img) { img.loading = 'eager'; img.sizes = '560px'; }
        }
        var c = $('[data-kk-contador]'); if (c) c.textContent = (act + 1) + ' / ' + total;
        esc.querySelectorAll('.kk-mini').forEach(function (m, i) { m.setAttribute('aria-current', String(i === act)); });
      };
      var mql = window.matchMedia('(min-width: 1000px)');
      var listo = false;
      var activar = function () { if (mql.matches && !listo) { listo = true; pintarFoto(); } };
      activar(); if (mql.addEventListener) mql.addEventListener('change', activar);
      esc.querySelectorAll('.kk-mini').forEach(function (m) { m.addEventListener('click', function () { act = parseInt(m.dataset.i, 10); pintarFoto(); }); });
      var prev = $('[data-kk-prev]'), next = $('[data-kk-next]');
      if (prev) prev.addEventListener('click', function () { act = (act + total - 1) % total; pintarFoto(); });
      if (next) next.addEventListener('click', function () { act = (act + 1) % total; pintarFoto(); });
    }

    /* Cantidad y resumen */
    var cant = $('[data-kk-cant]'), menos = $('[data-kk-menos]'), mas = $('[data-kk-mas]');
    var resumen = $('[data-kk-resumen]'), ctaTxt = $('[data-kk-cta-txt]'), cta = $('[data-kk-cta]');
    var fijaSub = $('[data-kk-fija-sub]'), envioBase = parseInt(root.dataset.envio, 10) || 0, umbral = parseInt(root.dataset.umbral, 10) || 0, muestras = root.dataset.muestras || '2 muestras de 30 ml';
    var cajasEnBolsa = 0, articulosEnBolsa = 0, totalBolsa = 0;
    var leerCant = function () {
      var q = parseInt(cant && cant.value, 10);
      if (!q || q < 1) q = 1; if (q > 12) q = 12;
      return q;
    };
    var pintar = function () {
      if (!cant) return;
      var q = leerCant();
      if (String(q) !== cant.value) cant.value = q;
      menos.disabled = q <= 1; mas.disabled = q >= 12;
      /* El precio mostrado solo considera los combos de esta selección (no los que ya están en la bolsa): 1 combo siempre $899. Shopify aplica el 2º combo en el checkout. */
      var antes = 0, despues = q - 1; /* cada combo después del primero a $820 (regla: toda salsa después de la 4ª a $205) */
      var descuento = (despues - antes) * desc2;
      /* Combos de 3: desde la 5ª salsa del pedido, cada salsa a $205 ($20 menos), igual que en el checkout */
      if (!desc2 && nsal < 4) descuento = 2000 * Math.max(0, nsal * q - 4);
      var costo = q * precio - descuento, envio = (umbral && costo + totalBolsa < umbral) ? envioBase : 0;
      var filas = [];
      filas.push('<div class="kk-r"><span>' + pl(q, 'combo', 'combos') + ' · ' + money(precio) + '</span><span class="v">' + money(q * precio) + '</span></div>');
      if (descuento > 0) filas.push('<div class="kk-r verde"><span>' + (!desc2 ? 'Salsas extra a $205' : (q > 2 ? 'Combos extra a ' : '2º combo a ') + money(precio - desc2)) + '</span><span class="v">−' + money(descuento) + '</span></div>');
      if (!(!desc2 && nsal < 4)) filas.push(envio ? '<div class="kk-r"><span>Envío</span><span class="v">' + money(envio) + '</span></div>' : '<div class="kk-r verde"><span>Envío</span><span class="v">Gratis</span></div>');
      filas.push('<div class="kk-r verde"><span>Regalo</span><span class="v">' + muestras + '</span></div>');
      if (articulosEnBolsa > 0) filas.push('<div class="kk-r tenue"><span>Ya en tu bolsa: ' + pl(articulosEnBolsa, 'artículo', 'artículos') + '</span><span class="v">' + money(totalBolsa) + '</span></div>');
      filas.push('<div class="kk-r total"><span>Total de esta selección</span><span class="v">' + money(costo + ((!desc2 && nsal < 4) ? 0 : envio)) + '</span></div>');
      if (resumen) resumen.innerHTML = filas.join('');
      if (ctaTxt && cta && !cta.disabled) ctaTxt.textContent = 'Agregar ' + (q === 1 ? 'combo' : q + ' combos') + ' · ' + money(costo);
      if (fijaSub) fijaSub.textContent = money(costo) + (envio ? ' + envío ' + money(envio) : ' · envío gratis');
    };
    var leerBolsa = function () {
      return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          articulosEnBolsa = c.item_count || 0; totalBolsa = c.total_price || 0;
          cajasEnBolsa = (c.items || []).reduce(function (a, it) { return a + (it.product_type === tipo ? it.quantity : 0); }, 0);
          pintar();
        }).catch(function () {});
    };
    if (cant) {
      menos.addEventListener('click', function () { cant.value = leerCant() - 1; pintar(); });
      mas.addEventListener('click', function () { cant.value = leerCant() + 1; pintar(); });
      cant.addEventListener('change', pintar);
      cant.addEventListener('input', function () { if (cant.value !== '') pintar(); });
      pintar(); leerBolsa();
    }

    /* Confirmación al agregar (el carrito lateral del theme se abre solo) */
    var ok = $('[data-kk-ok]'), okTxt = $('[data-kk-ok-txt]');
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (!ev || ev.source !== 'product-form') return;
        var q = leerCant();
        if (ok && okTxt) { okTxt.textContent = 'Agregaste ' + pl(q, 'combo', 'combos') + ' ' + nombre.replace(/^(Combo|Caja) /, '') + '.'; ok.hidden = false; }
        if (cant) cant.value = 1;
        leerBolsa();
      });
    }

    /* Ayuda de reposición */
    var abierto = null;
    var cerrarPop = function (foco) { if (!abierto) return; abierto.pop.hidden = true; abierto.btn.setAttribute('aria-expanded', 'false'); if (foco) abierto.btn.focus(); abierto = null; };
    root.querySelectorAll('[data-kk-pop-btn]').forEach(function (btn) {
      var pop = document.getElementById(btn.getAttribute('aria-controls'));
      if (!pop) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (abierto && abierto.pop === pop) { cerrarPop(true); return; }
        cerrarPop(false); pop.hidden = false; btn.setAttribute('aria-expanded', 'true'); abierto = { btn: btn, pop: pop }; pop.focus({ preventScroll: true });
      });
      pop.addEventListener('click', function (e) { if (e.target.closest('[data-kk-cerrar]')) cerrarPop(true); e.stopPropagation(); });
    });
    document.addEventListener('click', function () { cerrarPop(false); });

    /* Guía de picor */
    var fondo = $('[data-kk-guia-fondo]'), abrirGuia = $('[data-kk-abrir-guia]'), guiaAbierta = false;
    var cerrarGuia = function () { if (!guiaAbierta) return; fondo.hidden = true; guiaAbierta = false; document.documentElement.style.overflow = ''; if (abrirGuia) abrirGuia.focus(); };
    if (fondo && abrirGuia) {
      abrirGuia.addEventListener('click', function (e) {
        e.stopPropagation(); fondo.hidden = false; guiaAbierta = true; document.documentElement.style.overflow = 'hidden';
        var g = fondo.querySelector('[role="dialog"]'); if (g) g.focus({ preventScroll: true });
      });
      fondo.addEventListener('click', function (e) { if (e.target === fondo || e.target.closest('[data-kk-guia-cerrar]')) cerrarGuia(); });
      fondo.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = fondo.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])');
        if (!f.length) { e.preventDefault(); return; }
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (guiaAbierta) { e.preventDefault(); cerrarGuia(); }
      else if (abierto) { e.preventDefault(); cerrarPop(true); }
    });

    /* Reseñas: filtro y "ver más" */
    var lista = $('[data-kk-res-lista]'), masRes = $('[data-kk-res-mas]');
    if (lista) {
      var filtro = root.querySelector('[data-kk-filtro]') ? 'caja' : 'todas', todas = false;
      var pintarRes = function () {
        var vis = 0;
        lista.querySelectorAll('.kk-res').forEach(function (r) {
          var entra = filtro === 'todas' || r.dataset.caja === 'true';
          if (entra) vis++;
          r.hidden = !entra || (!todas && vis > 6);
        });
        var cuenta = 0; lista.querySelectorAll('.kk-res').forEach(function (r) { if (filtro === 'todas' || r.dataset.caja === 'true') cuenta++; });
        if (masRes) masRes.hidden = todas || cuenta <= 6;
        root.querySelectorAll('[data-kk-filtro]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.kkFiltro === filtro)); });
      };
      root.querySelectorAll('[data-kk-filtro]').forEach(function (b) { b.addEventListener('click', function () { filtro = b.dataset.kkFiltro; todas = false; pintarRes(); }); });
      if (masRes) masRes.addEventListener('click', function () { todas = true; pintarRes(); });
      pintarRes();
    }

    /* Barra fija móvil: aparece cuando el botón principal no se ve */
    var fija = $('[data-kk-fija]'), fijaCta = $('[data-kk-fija-cta]');
    if (fija && cta) {
      var vigilar = function () {
        var r = cta.getBoundingClientRect();
        var visible = r.bottom > 0 && r.top < window.innerHeight;
        fija.classList.toggle('ver', !visible);
        fija.setAttribute('aria-hidden', String(visible));
        if (fijaCta) fijaCta.tabIndex = visible ? -1 : 0;
      };
      window.addEventListener('scroll', vigilar, { passive: true });
      window.addEventListener('resize', vigilar);
      vigilar();
      if (fijaCta) fijaCta.addEventListener('click', function () {
        if (cta.disabled || cta.getAttribute('aria-disabled') === 'true') return;
        cta.click();
      });
    }
  }

  function arrancar() { document.querySelectorAll('.kk-cd').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();

/* Kauil Ki · Videos circulares de las salsas: se cargan al verse, en silencio y en loop; al tocar uno se abre en grande. */
(function () {
  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function cargar(v) { if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src; }
  function reproducir(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function iniciar(sec) {
    if (!sec || sec.dataset.kkVidListo) return;
    sec.dataset.kkVidListo = '1';
    var vids = [].slice.call(sec.querySelectorAll('.kk-vid video'));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { cargar(v); if (!reducir) reproducir(v); }
          else if (v.getAttribute('src')) v.pause();
        });
      }, { rootMargin: '200px 0px' });
      vids.forEach(function (v) { io.observe(v); });
    } else {
      vids.forEach(function (v) { cargar(v); if (!reducir) reproducir(v); });
    }
    var modal = sec.querySelector('[data-kk-vid-modal]');
    if (!modal) return;
    var grande = modal.querySelector('[data-kk-vid-grande]'), nom = modal.querySelector('[data-kk-vid-nom]');
    var ultimo = null;
    var cerrar = function () { grande.pause(); if (modal.open) { if (typeof modal.close === 'function') modal.close(); else modal.removeAttribute('open'); } };
    sec.querySelectorAll('[data-kk-vid]').forEach(function (b) {
      b.addEventListener('click', function () {
        var chico = b.querySelector('video');
        ultimo = b;
        grande.src = b.dataset.grande || (chico ? chico.dataset.src : '') || '';
        if (chico && chico.poster) grande.poster = chico.poster;
        grande.controls = reducir;
        nom.textContent = b.dataset.nombre + (b.dataset.picor && b.dataset.picor !== '0' ? ' · picor ' + b.dataset.picor + '/10' : '');
        if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');
        if (!reducir) reproducir(grande);
      });
    });
    modal.querySelector('[data-kk-vid-cerrar]').addEventListener('click', cerrar);
    modal.addEventListener('click', function (e) { if (e.target === modal) cerrar(); });
    modal.addEventListener('close', function () { grande.pause(); if (ultimo) ultimo.focus(); });
  }
  function arrancar() { document.querySelectorAll('[data-kk-videos]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
